/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ClassScheduleEntry } from './ClassScheduleEntry';
import {
    ClassScheduleEntryFromJSON,
    ClassScheduleEntryFromJSONTyped,
    ClassScheduleEntryToJSON,
    ClassScheduleEntryToJSONTyped,
} from './ClassScheduleEntry';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GenerateClassScheduleResponse
 */
export interface GenerateClassScheduleResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GenerateClassScheduleResponse
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GenerateClassScheduleResponse
     */
    className: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GenerateClassScheduleResponse
     */
    classRoomId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateClassScheduleResponse
     */
    classRoomName: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GenerateClassScheduleResponse
     */
    teachers: { [key: string]: string; };
    /**
     * 
     * @type {Array<ClassScheduleEntry>}
     * @memberof GenerateClassScheduleResponse
     */
    schedule: Array<ClassScheduleEntry>;
}

/**
 * Check if a given object implements the GenerateClassScheduleResponse interface.
 */
export function instanceOfGenerateClassScheduleResponse(value: object): value is GenerateClassScheduleResponse {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('classRoomName' in value) || value['classRoomName'] === undefined) return false;
    if (!('teachers' in value) || value['teachers'] === undefined) return false;
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    return true;
}

export function GenerateClassScheduleResponseFromJSON(json: any): GenerateClassScheduleResponse {
    return GenerateClassScheduleResponseFromJSONTyped(json, false);
}

export function GenerateClassScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateClassScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'classRoomId': ActorActivityRecordActorUserIdFromJSON(json['classRoomId']),
        'classRoomName': json['classRoomName'],
        'teachers': json['teachers'],
        'schedule': ((json['schedule'] as Array<any>).map(ClassScheduleEntryFromJSON)),
    };
}

export function GenerateClassScheduleResponseToJSON(json: any): GenerateClassScheduleResponse {
    return GenerateClassScheduleResponseToJSONTyped(json, false);
}

export function GenerateClassScheduleResponseToJSONTyped(value?: GenerateClassScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'classRoomId': ActorActivityRecordActorUserIdToJSON(value['classRoomId']),
        'classRoomName': value['classRoomName'],
        'teachers': value['teachers'],
        'schedule': ((value['schedule'] as Array<any>).map(ClassScheduleEntryToJSON)),
    };
}

